export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40e2674ccfb9de81b98d22cc46c3919ecbe82f3b67&name=revalidateCommunity!'